import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

// UTILITY
import { formatPrice } from '@/utility/currency';

import RadioContainer from './styles';

const planCard = ({ t, dataAttributes, onSeeChannelsClick, isSlingType, ...props }) => {
  const { data, plan, name, value, checkedValue, handleChange, handleBlur } = props;
  const isChecked = checkedValue === value;
  const showAsterisk = isSlingType && (data.name === 'Blue' || data.name === 'Orange & Blue');

  const getPrice = (price, interval) => {
    return price && Math.ceil(price) !== 0 ? (
      <>
        ${formatPrice(+price)}
        {!!interval && (
          <Typography component="span" color="textSecondary">
            /{interval}
          </Typography>
        )}
      </>
    ) : (
      t('common.free')
    );
  };

  return (
    <RadioContainer
      className={`radio-card noselect ${isChecked ? 'radio-card--checked' : ''}`}
      {...props}
    >
      <input
        type="radio"
        name={name}
        checked={isChecked}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        {...dataAttributes}
      />

      {isChecked ? (
        <RadioButtonCheckedIcon className="radio-card__icon" color="primary" fontSize="large" />
      ) : (
        <RadioButtonUncheckedIcon className="radio-card__icon" color="disabled" fontSize="large" />
      )}

      <Typography className="radio-card__title" variant="h5">
        {data.name}
      </Typography>

      <div className="radio-card__price">
        <Typography className="price p2">
          {getPrice(plan.price, plan.interval)} {showAsterisk ? '*' : null}
          {(!!plan.discount_price || plan.discount_price === 0) && (
            <span className="price__discount p4 text-color--purple">
              {getPrice(plan.discount_price)} {plan.discount_description}
            </span>
          )}
        </Typography>
        {data.has_trial && (
          <Typography className="p4 m-t-5 text-color--purple">
            {t('common.trialFirstDaysPeriod', { period: data.trial_days })}
          </Typography>
        )}
      </div>

      {data.channels.length ? (
        <Button
          type="button"
          className="radio-card__btn"
          color="primary"
          variant="outlined"
          size="medium"
          onClick={() => onSeeChannelsClick(true, data)}
        >
          {t('buttons.seeChannels')}
        </Button>
      ) : (
        <div className="radio-card__dummy-btn" />
      )}
    </RadioContainer>
  );
};

planCard.defaultProps = {
  handleChange: () => {},
  handleBlur: () => {},
  checkedValue: '',
  dataAttributes: {},
  onSeeChannelsClick: () => {},
  isSlingType: false,
};

planCard.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  checkedValue: PropTypes.string,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  dataAttributes: PropTypes.object,
  onSeeChannelsClick: PropTypes.func,
  isSlingType: PropTypes.bool,
};

export default React.memo(withTranslation()(planCard));
